@if (isPasswordChanged()) {
<app-auth-shell
  title="Senha alterada"
  icon="fas fa-circle-check"
  iconTone="success"
  subtitle="Sua senha foi alterada com sucesso. Agora você já pode entrar com a nova senha."
>
  <div class="auth-login__actions">
    <a class="auth-btn" [routerLink]="['/signin']">Ir para o login</a>
  </div>
</app-auth-shell>
} @else if (!hasResetLink()) {
<app-auth-shell
  title="Link inválido"
  icon="fas fa-link-slash"
  iconTone="danger"
  subtitle="Este link de redefinição está incompleto ou expirou. Solicite um novo para continuar."
>
  <div class="auth-login__actions">
    <a class="auth-btn" [routerLink]="['/forgot']">Solicitar novo link</a>
  </div>
  <p class="auth-login__signup" authShellFooter>
    Lembrou a senha?
    <a [routerLink]="['/signin']">Voltar para o login</a>
  </p>
</app-auth-shell>
} @else {
<app-auth-shell title="Redefinir senha" subtitle="Digite a nova senha e confirme.">
  <form class="auth-login__form" role="form" [formGroup]="formReset" (ngSubmit)="reset()" novalidate>
    <div class="auth-field">
      <label class="auth-field__label" for="password">Nova senha</label>
      <div class="auth-field__control">
        <input
          id="password"
          type="password"
          formControlName="password"
          class="auth-field__input auth-field__input--toggle"
          placeholder="Nova senha"
          autocomplete="new-password"
          appFocus
        />
        <button type="button" class="auth-field__toggle" appShow aria-label="Mostrar senha">
          <span><i class="fas fa-eye" aria-hidden="true"></i></span>
        </button>
      </div>
      @let passwordControl = formReset.get('password'); @let isPasswordEdited = !!passwordControl?.dirty; @if (isPasswordEdited &&
      passwordControl?.hasError('required')) {
      <div class="auth-field__error">Campo obrigatório</div>
      } @else if (isPasswordEdited && passwordControl?.hasError('strongPassword')) {
      <div class="auth-field__error">{{ passwordHint }}</div>
      } @else {
      <div class="auth-field__hint">{{ passwordHint }}</div>
      }
    </div>
    <div class="auth-field">
      <label class="auth-field__label" for="confirmPassword">Confirmar nova senha</label>
      <div class="auth-field__control">
        <input
          id="confirmPassword"
          type="password"
          formControlName="confirmPassword"
          class="auth-field__input auth-field__input--toggle"
          placeholder="Repita a nova senha"
          autocomplete="new-password"
        />
        <button type="button" class="auth-field__toggle" appShow aria-label="Mostrar senha">
          <span><i class="fas fa-eye" aria-hidden="true"></i></span>
        </button>
      </div>
      @if (formReset.get('confirmPassword')?.dirty) { @if (formReset.get('confirmPassword')?.hasError('required')) {
      <div class="auth-field__error">Campo obrigatório</div>
      } @if (formReset.get('confirmPassword')?.hasError('compare')) {
      <div class="auth-field__error">As senhas não conferem</div>
      } }
    </div>
    <button type="submit" class="auth-btn" [disabled]="!formReset.valid">Definir nova senha</button>
  </form>
  <p class="auth-login__signup" authShellFooter>
    Lembrou a senha?
    <a [routerLink]="['/signin']">Voltar para o login</a>
  </p>
</app-auth-shell>
}
